import { IPresenterProps } from './types';
import * as S from './styles';
import { ReactComponent as Star } from '../../assets/img/star.svg';
import { calculateAverageStarRating } from '../../utils/helpers';
import salon1 from '../../assets/img/stockSalons/salon1.jpg';
import salon2 from '../../assets/img/stockSalons/salon2.jpg';

const BusinessCardPresenter = (props: IPresenterProps) => {
    const scrollIntoView = () => {
        props.refProp?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (props.selected) {
        scrollIntoView()
    };

    // Calculate review count from starCount
    const reviewCount = props.business.starCount
        ? Object.values(props.business.starCount).reduce((a, b) => a + b, 0)
        : 0;

    // Show only first 3 services
    const displayedServices = props.business.services?.slice(0, 3) || [];
    const remainingServicesCount = (props.business.services?.length || 0) - 3;

    // Placeholder images for businesses without images
    const placeholders = [salon1, salon2];
    const getImageSrc = () => {
        if (props.business.img) return props.business.img;
        // Use business ID to deterministically select placeholder
        const hash = (props.business.id || '').charCodeAt(0) % placeholders.length;
        return placeholders[hash];
    };

    return (
        <S.Container
            to={{
                pathname: `/b/${(props.business.name || 'business').replace(/\s/g, '-')}`,
                state: {
                    navSelectedBusinessId: props.business.id as string,
                },
            }}
        >
            <S.BusinessSection>
                <S.ImageContainer>
                    <S.CardImage
                        src={getImageSrc()}
                        alt={props.business.name || 'Business'}
                    />
                </S.ImageContainer>

                <S.InfoContainer>
                    <S.LeftSideData>
                        <S.MainTitleContainer>
                            <S.Title>{props.business.name}</S.Title>
                        </S.MainTitleContainer>

                        {/* <S.Review>
                            <S.ReviewContainer>
                                <Star />
                                <S.ScoreText>{calculateAverageStarRating(props.business?.starCount)}</S.ScoreText>
                                {reviewCount > 0 && <S.ReviewCount>({reviewCount})</S.ReviewCount>}
                            </S.ReviewContainer>
                        </S.Review> */}

                        <S.LocationContainer>
                            <S.LocationInfo>{props.business?.fullAddress?.city || props.business?.area}</S.LocationInfo>
                        </S.LocationContainer>
                    </S.LeftSideData>
                </S.InfoContainer>
            </S.BusinessSection>

            <S.SeparatorLine key={props.business.id} />

            <S.ServicesSection>
                {displayedServices.map((service, index) => (
                    <S.ServicesContainer key={index}>
                        <S.ServiceItemDescription>
                            <S.ServiceItemDescriptionText>
                                {service.name}
                            </S.ServiceItemDescriptionText>
                        </S.ServiceItemDescription>

                        <S.ServiceItemDescription>
                            <S.ServiceItemDescriptionText>
                                <span>{service.duration} · </span>${service.price}
                            </S.ServiceItemDescriptionText>
                        </S.ServiceItemDescription>
                    </S.ServicesContainer>
                ))}

                {remainingServicesCount > 0 && (
                    <S.SeeAllServices>
                        Ver todos los {props.business.services?.length} servicios
                    </S.SeeAllServices>
                )}
            </S.ServicesSection>

        </S.Container>
    );
};

export default BusinessCardPresenter;
